import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DLMenu, Icon } from 'appSrc/components/UI';
import style from './styles/style.module.css';


export default class CopyDrop extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            open: false,
        };
        this.isCopying = false;
    }
    toggleMenuOpen = () => {
        var isOpen = !this.state.open;
        if( isOpen ) {
            this.isCopying = true;
            this.copyToClipboard();
            this.isCopying = false;
        }
        this.setState( { open: isOpen } );
    }
    copyToClipboard = () => {
        try {
            if ( navigator.userAgent.match( /ipad|ipod|iphone/i ) ) {
                var range = document.createRange();
                range.selectNodeContents( this._text );

                var s = window.getSelection();
                s.removeAllRanges();
                s.addRange( range );

                this._text.setSelectionRange(0, 999999);
            } else {
                this._text.select();
            }
            var successful = document.execCommand('copy');
            this.setState( { copySuccess: successful } );
        } catch (err) {
            this.setState( { copyMessage: false } );
        }
        this._text.blur();
    }
    componentDidUpdate = ( prevProps, prevState ) => {
        if( this.state.open && this.state.open !== prevState.open ) {
            this._x.focus();
        }
    }
    onBlur = () => {
        if( !this.isCopying ) {
            this.setState( { open: false } );
        }
    }
    render() {
        const { content } = this.props;
        const { open, copySuccess } = this.state;

        const copyMessage = ( copySuccess ) ?
            (
                <span><Icon source='fontAwesome' icon='fas/faCheckCircle' style={ { color: '#6461ec' } } /> Copied to clipboard</span>
            ) : (
                <span><Icon source='fontAwesome' icon='fas/faTimesCircle' style={ { color: 'red' } } /> Failed to copy automatically. Please copy manually</span>
            );
        return (
            <div className={ style.copyDrop }>
                <div className={ style.copyWrapper }>
                    <textarea className={ style.almostInvisible }
                    ref={ ( el ) => { this._text = el; } }
                    defaultValue={ content }></textarea>
                </div>
                <DLMenu
                icon={ ( <Icon source='fontAwesome' icon='fas/faLink' style={ { color: '#6461ec' } }
                    onClick={ this.toggleMenuOpen } /> ) }
                direction={ this.props.direction }
                open={ open }
                onBlur={ this.onBlur }
                autoFocus={ open }>
                    <div className={ style.menuBlock }>
                        <p className={ style.copyMessage }>{ copyMessage }</p>
                        <pre className={ style.copyCode }>{ content }</pre>
                        <div className={ style.copyWrapper }>
                            <input type='text' className={ style.almostInvisible }
                            ref={ ( el ) => { this._x = el; } } />
                        </div>
                    </div>
                </DLMenu>
            </div>
        );
    }
}
CopyDrop.defaultProps = {
    content: '',
    direction: 'left',
};
CopyDrop.propTypes = {
    content: PropTypes.string,
    direction: PropTypes.string,
};
